import styled from "styled-components"
import { NATIVE_ANIMATION_FRAME_WIDTH, TEXT_TRANSITION_DURATION_IN_SECONDS } from "../burnout-animation-constants";

interface ICongratulationsTextBoxProps {
    animationWidth: number;
    show: boolean;
}
export const CongratulationsTextBox = styled.div<ICongratulationsTextBoxProps>`
    position: absolute;
    z-index: 2;
    width: 100%;
    top: 66%;
    text-align: center;
    color: ${({theme}) => theme.colors.brandSecondary};
    -webkit-text-stroke: 2px ${({theme}) => theme.colors.backgroundLight};
    ${({theme}) => theme.font.presets.ultra};

    font-size: ${({animationWidth}) => animationWidth * 33 / NATIVE_ANIMATION_FRAME_WIDTH}px;
    line-height: 1.1;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: ${({animationWidth}) => animationWidth * 39 / NATIVE_ANIMATION_FRAME_WIDTH}px;
        letter-spacing: -0.5px;
    }

    transition: opacity ${TEXT_TRANSITION_DURATION_IN_SECONDS}s, transform ${TEXT_TRANSITION_DURATION_IN_SECONDS}s;
    opacity: ${({show}) => show ? 1 : 0};
    transform: scale(${({show}) => show ? 1 : 0.25});
`;
